<template>
  <PlainLayout>
    <DashboardTopCards />
    <EventList />
  </PlainLayout>
</template>

<script setup lang="ts">
import DashboardTopCards from "@/ui/components/DashboardTopCards.vue";
import { inject } from "vue";
import EventList from "../components/events/EventList.vue";
import PlainLayout from "../layouts/PlainLayout.vue";

const updateMeta = inject("updateMeta") as (meta) => void;

updateMeta({
  title: "4CPredictions - Home",
});
</script>
